<span
    class="text-reactive"
    [ngClass]="{'text-elevation' : (elevation === label)}"
    (mouseover)="setElevation( label + ' button')"
    (focus)="setElevation( label + ' button')"
    (mouseleave)="setElevation('')">
    {{ description }}
</span>
